package com.ervasstudio.tracoemovimento.pages.home

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.sections.Footer
import com.ervasstudio.tracoemovimento.components.sections.Header
import com.ervasstudio.tracoemovimento.util.rememberIsMobile
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import org.jetbrains.compose.web.css.vw



@Composable
fun InicioPage() {
    val isMobile = rememberIsMobile()
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight()
        ,
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Header(expandedItem = 0, isMobile = isMobile)
        MainSection(isMobile = isMobile)
        TracoEMovimentoSection(isMobile = isMobile)
        SeccaoPretaHome(isMobile = isMobile)
        //Footer(true, isMobile = isMobile)

    }
}